import { useState } from "react";
import axios from "axios";
import { Envelope, LockKey, SignIn, Warning } from "@phosphor-icons/react";import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function foutTekst(detail) {
  if (!detail) return "Inloggen mislukt. Probeer opnieuw.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  return String(detail.msg || detail);
}

export default function Login({ onLogin }) {
  const [email, setEmail] = useState("");
  const [wachtwoord, setWachtwoord] = useState("");
  const [fout, setFout] = useState("");
  const [bezig, setBezig] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setFout("");
    setBezig(true);
    try {
      const res = await axios.post(`${API}/auth/login`, { email, wachtwoord });
      onLogin(res.data);
    } catch (err) {
      setFout(foutTekst(err.response?.data?.detail) || err.message);
    } finally {
      setBezig(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F4F5F7] flex items-center justify-center p-4" data-testid="login-screen">
      <div className="w-full max-w-sm">
        <div className="mb-8">
          <img
            src="/logo512.png"
            alt="Personeel Register"
            className="w-14 h-14 rounded-sm object-contain mb-4"
            data-testid="login-logo"
          />
          <h1 className="text-2xl font-black tracking-tight" style={{ fontFamily: "Chivo, sans-serif" }}>
            Personeel Register
          </h1>
          <p className="text-xs tracking-[0.2em] uppercase font-bold text-muted-foreground mt-1">
            Multi-firma beheer
          </p>
        </div>

        <form onSubmit={submit} className="bg-white border border-border rounded-sm p-6" data-testid="login-form">
          <label className="block text-xs font-bold uppercase tracking-[0.15em] text-muted-foreground mb-1.5">
            E-mailadres
          </label>
          <div className="relative mb-4">
            <Envelope size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="naam@firma.be"
              autoComplete="username"
              required
              className="rounded-sm pl-9 h-11"
              data-testid="login-email-input"
            />
          </div>

          <label className="block text-xs font-bold uppercase tracking-[0.15em] text-muted-foreground mb-1.5">
            Wachtwoord
          </label>
          <div className="relative mb-5">
            <LockKey size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
            <Input
              type="password"
              value={wachtwoord}
              onChange={(e) => setWachtwoord(e.target.value)}
              placeholder="••••••••"
              autoComplete="current-password"
              required
              className="rounded-sm pl-9 h-11"
              data-testid="login-password-input"
            />
          </div>

          {fout && (
            <div className="mb-4 flex items-start gap-2 bg-[#E53E3E]/10 border border-[#E53E3E]/30 rounded-sm p-2.5" data-testid="login-error">
              <Warning size={16} weight="bold" className="text-[#E53E3E] mt-0.5 shrink-0" />
              <p className="text-sm text-[#E53E3E] font-medium">{fout}</p>
            </div>
          )}

          <Button
            type="submit"
            disabled={bezig}
            className="w-full h-11 rounded-sm bg-[#002FA7] hover:bg-[#002280] font-bold"
            data-testid="login-submit-btn"
          >
            <SignIn size={18} weight="bold" className="mr-2" />
            {bezig ? "Inloggen..." : "Inloggen"}
          </Button>
        </form>
      </div>
    </div>
  );
}
